import axiosInstance from "./axios";

const getOrderData = async (id) => {
  const response = await axiosInstance.get(`/back/order/details/${id}`)
  return response
}

const confirmPayLetter = async (id) => {
  const response = await axiosInstance.post(`oms/order/${id}/pay-later`)
  return response
}

const order = {
  getOrderData,
  confirmPayLetter
}

export default order
